import { createSelector } from 'reselect';
import { RootState } from '../rootReducer';
import { EventAttributesState } from './eventAttributes.types';

const selectEventAttributesState = (state: RootState): EventAttributesState =>
  state.eventAttributes;

export const selectEventAttributes = createSelector(
  [selectEventAttributesState],
  (eventAttributesState) => eventAttributesState.eventAttribute
);

export const selectEventAttributesLoading = createSelector(
  [selectEventAttributesState],
  (eventAttributesState) => eventAttributesState.loading
);

export const selectEventAttributesError = createSelector(
  [selectEventAttributesState],
  (eventAttributesState) => eventAttributesState.error
);
